import React from 'react';
import { PermissionsCheck } from '../../Components/Auth/PermissionsCheck';
import { Button, ButtonSize } from '../../Components/Button';
import { PlusIcon } from '../../Components/Icons';
import MedicationListNotFound from '../../Images/medicationListNotFound.svg';
import MedicationsNotFound from '../../Images/medicationsNotFound.svg';
import { MedicationsPermissions } from '../../MedicationsPermissions';
import { white } from '../../Styles/Colours';
import styles from './MedicationListErrors.module.css';
export var MedicationListErrors = function (props) {
    if (props.hasEntries)
        return null;
    var graphic = props.hasQuery ? (React.createElement("img", { src: MedicationsNotFound, alt: '' })) : (React.createElement("img", { src: MedicationListNotFound, alt: '' }));
    var text = props.hasQuery ? (React.createElement("span", null,
        "No medications found.",
        React.createElement("br", null),
        "Refine your search and try again.")) : (React.createElement("span", null,
        "No medication list items found.",
        React.createElement("br", null),
        "Create a medication list."));
    var actionButton = !props.hasQuery && !props.hasPublished && (React.createElement(PermissionsCheck, { permission: MedicationsPermissions.WriteMedicationLists },
        React.createElement("div", { className: styles.buttonContainer },
            React.createElement(Button, { testId: 'add-medication-list', startIcon: React.createElement(PlusIcon, { color: white }), size: ButtonSize.medium, onClick: props.onAddAction }, "Add medication list"))));
    return (React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.placeholder },
            React.createElement("div", { className: styles.placeholderContent },
                graphic,
                React.createElement("div", { className: styles.placeholderTitleText }, text),
                actionButton))));
};
